export default __webpack_public_path__ + "static/media/msg.5e13ca1f.mp3";